import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "projects-grid" }
const _hoisted_2 = { class: "project-image-wrapper" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "project-content" }
const _hoisted_5 = { class: "project-card-header" }
const _hoisted_6 = { class: "project-category" }
const _hoisted_7 = { class: "project-title" }
const _hoisted_8 = { class: "project-description" }
const _hoisted_9 = { class: "project-tags" }
const _hoisted_10 = { class: "project-action" }
const _hoisted_11 = ["href", "aria-label"]

import { motion } from "motion-v"
import BaseSection from "@/views/sections/BaseSection.vue"
import GradientTitle from "@/components/GradientTitle.vue"

interface ProjectItem {
  title: string
  category: string
  description: string
  tags: string[]
  link: string
  linkText: string
  image: string
  imageAlt: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectsSection',
  setup(__props) {

const projects: ProjectItem[] = [
  {
    title: 'Bauzaunex',
    category: 'B2B-Bestellportal & E-Commerce System',
    description: 'Ganzheitliche Entwicklung eines High-Performance B2B-Bestellportals für Mobilzäune und Absperrungen. Inklusive 60-Sekunden Express-Besteller, automatisierter Frachtkostenberechnung (Google Distance Matrix API) und 100 % organischer SEO-Strategie.',
    tags: ['Nuxt 4', 'Nitro Engine', 'Vue 3', 'Pinia', 'TypeScript', 'Docker', 'Kubernetes'],
    link: 'https://bauzaun.hamburg/',
    linkText: 'Bauzaun Hamburg – Mobilzaun B2B Portal besuchen',
    image: 'bauzaunex-preview.png',
    imageAlt: 'Bauzaunex B2B-Bestellportal Vorschau'
  },
  {
    title: 'Hottexo Germany',
    category: 'B2B Plattform & Digitales Produkt',
    description: 'Konzeption, UI/UX Design und Entwicklung einer modernen B2B-Homepage für selbsterhitzende Verpflegungslösungen. Optimiert für hohe Conversion-Raten und schnelle Ladezeiten.',
    tags: ['Nuxt 4', 'Nuxt UI', 'Tailwind CSS', 'TypeScript', 'GitOps'],
    link: 'https://selbsterhitzendes-essen.de/',
    linkText: 'Hottexo Germany besuchen',
    image: 'hottexo-preview.jpg',
    imageAlt: 'Hottexo Germany Homepage Vorschau'
  }
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseSection, { "background-style": "light" }, {
    default: _withCtx(() => [
      _createVNode(_unref(motion).div, {
        class: "projects-header",
        initial: { opacity: 0, y: 30 },
        whileInView: { opacity: 1, y: 0 },
        transition: { duration: 0.6 },
        inViewOptions: { once: true }
      }, {
        default: _withCtx(() => [
          _createVNode(GradientTitle, {
            text: "Ausgewählte Projekte",
            tag: "h2"
          }),
          _cache[0] || (_cache[0] = _createElementVNode("p", { class: "projects-subtitle" }, "Ein Einblick in aktuelle Webanwendungen und Plattformen", -1))
        ]),
        _: 1,
        __: [0]
      }),
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(projects, (project, index) => {
          return _createVNode(_unref(motion).article, {
            key: project.title,
            class: "project-card",
            initial: { opacity: 0, y: 30 },
            whileInView: { opacity: 1, y: 0 },
            transition: { delay: index * 0.2, duration: 0.6 },
            inViewOptions: { once: true }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("img", {
                  src: require(`@/assets/${project.image}`),
                  alt: project.imageAlt,
                  class: "project-image"
                }, null, 8, _hoisted_3)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(project.category), 1),
                  _createElementVNode("h3", _hoisted_7, _toDisplayString(project.title), 1)
                ]),
                _createElementVNode("p", _hoisted_8, _toDisplayString(project.description), 1),
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.tags, (tag) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: tag,
                      class: "project-tag"
                    }, _toDisplayString(tag), 1))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("a", {
                    href: project.link,
                    target: "_blank",
                    rel: "noopener",
                    class: "project-link",
                    "aria-label": `Website besuchen: ${project.title}`
                  }, [
                    _createElementVNode("span", null, _toDisplayString(project.linkText), 1),
                    _cache[1] || (_cache[1] = _createElementVNode("svg", {
                      class: "external-icon",
                      viewBox: "0 0 24 24",
                      width: "16",
                      height: "16",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      fill: "none",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, [
                      _createElementVNode("path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" }),
                      _createElementVNode("polyline", { points: "15 3 21 3 21 9" }),
                      _createElementVNode("line", {
                        x1: "10",
                        y1: "14",
                        x2: "21",
                        y2: "3"
                      })
                    ], -1))
                  ], 8, _hoisted_11)
                ])
              ])
            ]),
            _: 2
          }, 1032, ["transition"])
        }), 64))
      ])
    ]),
    _: 1
  }))
}
}

})